  

import CloudDoneIcon from '@mui/icons-material/CloudDone'; // 🟢 Synchronisiert
import CloudSyncIcon from '@mui/icons-material/CloudSync'; // 🟡 Bearbeitet
import { marked } from 'marked';
import { Menu, MenuItem } from "@mui/material";
import { Document, Packer, Paragraph } from "docx";
// import { saveAs } from "file-saver";
import ConfigureDialogContent from "./ConfigureDialogContent";
import ReactQuill, { Quill } from "react-quill";
import 'react-quill/dist/quill.snow.css';
import React, { useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";
import { useSessionStore, labelMap } from "./SessionStore"; // Zustand-Store für die aktuelle Sitzung
import Tooltip from './components/Tooltip';

import MicIcon from '@mui/icons-material/Mic';
import StopIcon from '@mui/icons-material/Stop';
import MicNoneIcon from '@mui/icons-material/MicNone';
import MicOffIcon from '@mui/icons-material/MicOff';
import SessionDetails from './SessionDetails';
import ConfigureDialog from "./ConfigureDialog";
import html2md from 'html-to-md';
import { useSiteSettings } from './context/SiteSettingsContext';
const Documentation = () => {
  // Binde sessionStore ein
  const { settings: siteSettings, loading: isSiteSettingsLoading } = useSiteSettings();
  const logLevel = siteSettings?.frontend_log_level ?? 0;;
  const sessions = useSessionStore((s) => s.sessions);
  const { selectedSessionId } = useSessionStore();
  const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(null);
  const { sessionData, updateSession } = useSessionStore();
  const [isEdited, setIsEdited] = useState(false);

  // Zustand-Store für die aktuelle Sitzung
  const [editorContent, setEditorContent] = useState('');
  const [pendingChanges, setPendingChanges] = useState<Record<string, string>>({});
  const [markdownDoku, setMarkdownDoku] = useState<string | "">(sessionData?.documentation?.documentation!);
  const [htmlContent, setHtmlContent] = useState('');
  const quillRef = useRef<ReactQuill | null>(null);
  const isEditedRef = useRef(false);
  // Ref, um System-Updates von User-Edits zu unterscheiden

  const isSystemUpdate = useRef(false);

  // Ref, um die zuletzt geladene SessionId zu speichern
  const lastLoadedSessionId = useRef<number | null>(null);


  // Für temporäre Statusänderungen
  const currentSession = sessions.find((s) => s.id === selectedSessionId);
  const isCompleted = currentSession?.tempStatus === "completed";

  const [copyFeedbackVisible, setCopyFeedbackVisible] = useState(false);
  const [selectedLlm, setSelectedLlm] = useState<string>("meta-llama/Llama-3.3-70B-Instruct");
  const [loading, setLoading] = useState(false);
  const editorContentRef = useRef('');
  const htmlContentRef = useRef('');

  const [quillVisible, setQuillVisible] = useState(true);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);


  const [dialogOpen, setDialogOpen] = useState(false);
  const [promptTemplates, setPromptTemplates] = useState<any[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<number | null>(null);
  const [llmModels, setLlmModels] = useState<string[]>([
    "meta-llama/Llama-3.3-70B-Instruct",
    "mistralai/Mistral-7B-Instruct-v0.3",
    "meta-llama/Meta-Llama-3.1-8B-Instruct",
    "mistralai/Mixtral-8x7B-Instruct-v0.1",
  ]);

  // Dynamische, editierbare Felder aus der Dokumentation
  const [openDictation, setOpenDictation] = useState(false);
  const recordingRef = useRef(false);
  const [mediaRecorder, setMediaRecorder] = useState<MediaRecorder | null>(null);
  const [audioChunks, setAudioChunks] = useState<Blob[]>([]);
  const [currentInputIndex, setCurrentInputIndex] = useState<number | null>(null);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const [cursorPos, setCursorPos] = useState<{ x: number, y: number } | null>(null);
  const audioChunksRef = useRef<Blob[]>([]);
  const initialMountDone = useRef(false);
  const [quillMounted, setQuillMounted] = useState(true);
  // State für das Anzeigen/Ausblenden der SessionDetails-Komponente
  const [showSessionDetails, setShowSessionDetails] = useState(true);
  // Sichtbarkeit des Recording-Panels
  const [isRecordingVisible, setIsRecordingVisible] = useState(false);
  // Hilfsfunktion zur Dokumentations-Bereinigung für alle Export-/Kopierfunktionen


  const cleanDocumentation = (htmlContent: string, sessionData: any) => {
    // Erstellt Markdown aus HTML und wandelt *-Listenpunkte in - um
    const markdown = html2md(htmlContent || '').replace(/^\*\s+/gm, '- '); // Wandelt *-Listenpunkte in - um
    let text = markdown
      .replace(/^(#{1,6} .+)(\n[^\n])/gm, '$1\n\n$2') // Leerzeile nach jeder Überschrift
      .replace(/^#{1,6}\s*(.*)$/gm, '$1')             // Entfernt alle Markdown-Überschriften
      .replace(/\*\*(.*?)\*\*/g, '$1')                // Entfernt **Fettschrift**
      .replace(/((?:\n[-*+]\s.*)+)\n(#{1,6}\s+)/g, '$1\n\n$2') // Zwei Leerzeilen zwischen Listen und Überschriften
      .replace(/\n{3,}/g, '\n\n')
      .trim();

    const lengthInMinutes = sessionData?.length ? Math.round(Number(sessionData.length) / 60) : "Unbekannt";
    const rawDate = sessionData?.date ? new Date(sessionData.date) : null;
    const formattedDate = rawDate
      ? `${String(rawDate.getDate()).padStart(2, '0')}.${String(rawDate.getMonth() + 1).padStart(2, '0')}.${rawDate.getFullYear()}`
      : "Unbekannt";
    const header = `Name: ${sessionData?.name}\nDatum: ${formattedDate}\n\n`;  // Länge: ${lengthInMinutes} Minuten\n\n`;
    return header + text;
  };


  // Setze Editor-Inhalt bei Änderung der Dokumentation in sessionData
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      if (dialogOpen) {
        setDialogOpen(false); // 🔒 Dialog schließen statt zurücknavigieren
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [dialogOpen]);

  useEffect(() => {
    if (!sessionData?.documentation?.documentation) return;

    if (isEdited && lastLoadedSessionId.current === sessionData?.id) {
      setIsEdited(false);
      isEditedRef.current = false;
      return;
    }

    const markdown = sessionData.documentation.documentation;
    const html = marked.parse(markdown) as string;
    lastLoadedSessionId.current = sessionData?.id;
    isSystemUpdate.current = true;

    // Editor kurz aus- und einblenden
    setQuillVisible(false);
    initialMountDone.current = false;

    setTimeout(() => {
      setEditorContent(html);

      // Dictation-Button beim ersten Mount korrekt disabled setzen
      setTimeout(() => {
        const toolbarButton = document.querySelector('.ql-toolbar button.ql-dictation') as HTMLButtonElement | null;
        if (toolbarButton) {
          toolbarButton.disabled = true;
        }
      }, 100);

      setTimeout(() => {
        const editor = quillRef.current?.getEditor();
        if (editor) {
          const history = editor.getModule('history');
          if (history && typeof history.clear === 'function') {
            history.clear();
          }
        }
      }, 100);
    }, 50);

    setIsEdited(false);
    if (!isSiteSettingsLoading && logLevel >= 3) console.log("New loaded:");
  }, [sessionData]);


  // Setze isEdited, wenn sich der Editor-Inhalt vom geladenen HTML unterscheidet
  useEffect(() => {
    if (isSystemUpdate.current) {
      isSystemUpdate.current = false;
      return;
    }
    if (editorContentRef.current === htmlContentRef.current) {
      setIsEdited(false);
      isEditedRef.current = false;
      return;
    }
    setIsEdited(true);
    isEditedRef.current = true;

  }, [editorContent]);

  useEffect(() => {
    if (!quillVisible) {
      setQuillMounted(false);
    }
  }, [quillVisible]);


  // Auto-Save nach 5 Sekunden Inaktivität
  useEffect(() => {
  
    if (sessionData?.documentation_locked) return;

    const timeout = setTimeout(async () => {
      if (!isEditedRef.current) return;
      if (!sessionData?.id) return;
      try {
        const markdown = html2md(editorContentRef.current);
        const existingData = sessionData?.documentation || {};
        const updatedData = {
          ...existingData,
          documentation: markdown,
        };

        await axios.put("/api/apps/update-session/", {
          id: sessionData.id,
          documentation: updatedData,
        });
        htmlContentRef.current = editorContentRef.current; // HTML-Inhalt nach dem Speichern aktualisieren
        if (!isSiteSettingsLoading && logLevel >= 3) console.log("✅ Dokumentation automatisch gespeichert");
      } catch (error) {
        if (!isSiteSettingsLoading && logLevel >= 1) console.error("❌ Fehler beim Auto-Speichern der Dokumentation:", error);
      }
    }, 2000);

    return () => clearTimeout(timeout);
  }, [editorContent]);


  useEffect(() => {
    if (!quillMounted) {
      const timeout = setTimeout(() => {
        setQuillVisible(true);

        setQuillMounted(true);
      }, 50); // leicht verzögert

      return () => clearTimeout(timeout);
    }
  }, [quillMounted]);


  // useEffect zum Laden der PromptTemplates

  useEffect(() => {
    const fetchPromptTemplates = async () => {
      try {
        const response = await axios.get("/api/apps/fetch-templates");
        setPromptTemplates(response.data);
      } catch (error) {
        if (!isSiteSettingsLoading && logLevel >= 1) console.error("Fehler beim Laden der PromptTemplates:", error);
      }
    };
    // Initiales Laden der PromptTemplates
    fetchPromptTemplates();
    const interval = setInterval(fetchPromptTemplates, 60000); // Automatische Aktualisierung alle 60 Sekunden
    return () => clearInterval(interval); // Beim Verlassen der Komponente den Timer löschen
  }, []);

  useEffect(() => {
    if (promptTemplates.length > 0 && selectedTemplate === null) {
      setSelectedTemplate(promptTemplates[0].id);
    }
  }, [promptTemplates]);


  const [text, setText] = React.useState("");

  // add in the undo/redo icons

  var icons = Quill.import("ui/icons");
  icons["undo"] = `<svg viewbox="0 0 18 18">
    <polygon class="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10"></polygon>
    <path class="ql-stroke" d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"></path>
  </svg>`;
  icons["redo"] = `<svg viewbox="0 0 18 18">
    <polygon class="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10"></polygon>
    <path class="ql-stroke" d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"></path>
  </svg>`;
icons["dictation"] = `<svg viewBox="0 0 22 22"><path d="M12 14a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v5a3 3 0 0 0 3 3zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 14 0h-2zm-5 9v-2h2v-2h-4v2h2v2h2z"/></svg>`;
  let quillEditor: any;


  const modules = useMemo(
    () => ({
      history: { delay: 200, maxStack: 500, userOnly: true },
      toolbar: {
        container: [
          [{ header: [1, 2, 3, false] }],
          ['bold', 'italic', 'underline'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['clean'],
          ['undo', 'redo'],
          ['dictation'],
        ],
        handlers: {
          undo: () => {
            const editor = quillRef.current?.getEditor();
            editor?.getModule('history')?.undo?.();
          },
          redo: () => {
            const editor = quillRef.current?.getEditor();
            editor?.getModule('history')?.redo?.();
          },
          dictation: () => {
            // ---- Cursor check ganz oben einfügen ----
            const editor = quillRef.current?.getEditor();
            const range = editor?.getSelection();
            if (!range) {
              console.warn('⚠️ Kein Cursor im Editor. Diktat nicht gestartet.');
              return;
            }
            // -----------------------------------------
            if (recordingRef.current) {
              mediaRecorder?.stop();
              recordingRef.current = false;
              setIsRecordingVisible(false);
            } else {
              navigator.mediaDevices.getUserMedia({ audio: true })
                .then(stream => {
                  const recorder = new MediaRecorder(stream);

                  recorder.ondataavailable = (event) => {
                    if (event.data.size > 0) {
                      audioChunksRef.current.push(event.data);
                    }
                  };

                  recorder.onstop = async () => {
  const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });

  const formData = new FormData();
  formData.append('audio', audioBlob, 'dictation.webm');

  try {
    const response = await axios.post('/api/services/transcribe-dictation/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    const transcript = response.data?.transcription?.trim?.();
    if (transcript) {
      const editor = quillRef.current?.getEditor();
      const range = editor?.getSelection();
      if (editor && range) {
        {/*const [leaf, offset] = editor.getLeaf(range.index);
        const node = leaf?.domNode?.parentNode as HTMLElement | null;
        if (node) {
          node.classList.remove('blurred'); // HIER: Blur wegnehmen direkt vor Einfügen
        }*/}  

        const prevChar = editor.getText(Math.max(0, range.index - 1), 1);
        const nextChar = editor.getText(range.index, 1);
        const needsSpaceBefore = prevChar && !/\s/.test(prevChar);
        const needsSpaceAfter = nextChar && !/\s/.test(nextChar);
        const finalText = `${needsSpaceBefore ? ' ' : ''}${transcript}${needsSpaceAfter ? ' ' : ''}`;

        let currentIndex = 0;
        const typeNextChar = () => {
          if (currentIndex < finalText.length) {
            const char = finalText[currentIndex];
            editor.insertText(
              range.index + currentIndex,
              char,
              
              "user"
            );
            currentIndex++;
            setTimeout(typeNextChar, 13); // Geschwindigkeit anpassen (40ms pro Zeichen)
          } else {
            setIsRecordingVisible(false);
            editor.setSelection(range.index, finalText.length);
          }
        };
        typeNextChar();
      }
    }

  } catch (error) {
    console.error('❌ Fehler beim Transkribieren:', error);
  }
};

                  audioChunksRef.current = [];
                  recorder.start();
                  setMediaRecorder(recorder);
                  recordingRef.current = true;
                  setIsRecordingVisible(true);
                  
                {/* const editorInstance = quillRef.current?.getEditor();
const rangeInstance = editorInstance?.getSelection();
if (editorInstance && rangeInstance) {
  const [leaf, offset] = editorInstance.getLeaf(rangeInstance.index);
  const node = leaf?.domNode?.parentNode as HTMLElement | null;
  if (node) {
    node.classList.add('blurred');
  }
}*/} 
                })
                .catch(error => {
                  console.error('❌ Fehler beim Zugriff auf das Mikrofon:', error);
                });
            }
          },
        },
      },
      clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: false,
      },
    }),
    [siteSettings]
  );



  const handleTextFieldClick = (index: number, event: React.MouseEvent<HTMLElement> | React.FocusEvent<HTMLElement>) => {
    const target = event.target as HTMLTextAreaElement | HTMLInputElement;
    if (!target.selectionStart) return; // Sicherstellen, dass es sich um ein Textfeld handelt

    const rect = target.getBoundingClientRect();
    const cursorX = rect.left + window.scrollX + target.selectionStart * 8; // Anpassung für Schriftgröße
    const cursorY = rect.top + window.scrollY - 30; // Button über dem Cursor positionieren

    setCurrentInputIndex(index);
    setCursorPos({ x: cursorX, y: cursorY });
  };
  
  const startRecording = () => {
    audioChunksRef.current = []; // 🔴 Vor jeder neuen Aufnahme alte Daten löschen

    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(stream => {
        const recorder = new MediaRecorder(stream);

        recorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            audioChunksRef.current.push(event.data); // 🔄 Direkt ins Ref speichern
          }
        };

        recorder.onstop = () => {
          if (!isSiteSettingsLoading && logLevel >= 3) console.log("📌 Aufnahme gestoppt, `audioChunksRef`:", audioChunksRef.current);
        };

        recorder.start();
        setMediaRecorder(recorder);
        //setRecording(true);
      })
      .catch(error => console.error("❌ Fehler beim Zugriff auf das Mikrofon:", error));
  };

  const saveChanges = async () => {
    if (Object.keys(pendingChanges).length === 0) return;

    try {
      if (!sessionData || !sessionData.id) {
        if (!isSiteSettingsLoading && logLevel >= 1) console.error("❌ Fehler: sessionData oder sessionData.id ist null");
        return;
      }
      await axios.put("/api/services/update-documentation-fields/", {
        session_id: sessionData.id,
        updated_fields: pendingChanges
      });

      if (!isSiteSettingsLoading && logLevel >= 3) console.log("✅ Änderungen gespeichert:", pendingChanges);
      setPendingChanges({}); // Zurücksetzen nach dem Speichern
    } catch (error) {
      if (!isSiteSettingsLoading && logLevel >= 1) console.error("❌ Fehler beim Speichern der Änderungen:", error);
    }
  };

  // Funktion zum Senden der Dokumentationsanforderung
  const handleGenerateDocumentation = async () => {
    if (!selectedTemplate) {
      alert("Bitte ein Prompt-Template auswählen!");
      return;
    }
    if (!sessionData || !sessionData.id) {
      alert("Keine Sitzung ausgewählt!");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post("/api/services/generate-documentation/", {
        user_sitzung_id: sessionData.id, // Sitzungs-ID aus SessionStore
        prompt_template_id: selectedTemplate,
        llm_model: selectedLlm
      });

    } catch (error) {
      if (!isSiteSettingsLoading && logLevel >= 1) console.error("Fehler beim Generieren der Dokumentation:", error);
      alert("Fehler beim Generieren der Dokumentation.");
    } finally {
      setLoading(false);
    }
  };

  const updateDocumentationText = (newValue: string) => {
    setEditorContent(newValue);
  };

  const handleOpenDictation = () => {
    setOpenDictation(true);
    startRecording(); // 🔥 Aufnahme direkt starten!
  };

  const handleDownloadClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownloadText = () => {
    const text = cleanDocumentation(editorContentRef.current, sessionData);
    const blob = new Blob([text], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Luma_Doku_${sessionData?.date}_${sessionData?.name}.txt`;
    a.click();
    URL.revokeObjectURL(url);
    handleClose();
  };

  const handleDownloadWord = async () => {
  const text = cleanDocumentation(editorContentRef.current, sessionData);
  const bodyLines = text.split('\n');

  const doc = new Document({
    sections: [
      {
        children: bodyLines.map(line => new Paragraph(line)),
      },
    ],
  });
  const blob = await Packer.toBlob(doc);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `Luma_Doku_${sessionData?.date}_${sessionData?.name}.docx`;
  a.click();
  URL.revokeObjectURL(url);
  handleClose();
};

  const handleDownloadPDF = () => {
    const text = cleanDocumentation(editorContentRef.current, sessionData);
    const formattedText = text.replace(/\n/g, '<br/>');
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(`
        <html>
          <head><title>Luma_Doku_${sessionData?.date}_${sessionData?.name}</title></head>
          <body><p>${formattedText}</p></body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    }
    handleClose();
  };

  // Kopieren als Markdown-Text mit Bereinigung
  const handleCopyToClipboard = () => {
    const text = cleanDocumentation(editorContentRef.current, sessionData);
    navigator.clipboard.writeText(text)
      .then(() => {
        setCopyFeedbackVisible(true);
        setTimeout(() => setCopyFeedbackVisible(false), 2000);
      })
      .catch(err => {
        if (!isSiteSettingsLoading && logLevel >= 1) console.error("❌ Fehler beim Kopieren:", err);
      });
  };

  const handleOpenDialog = () => {
    setDialogOpen(true);
    window.history.pushState({ dialog: true }, '', '');
  };
  const transcript = sessionData?.data?.Transcript?.Text;
  if (!transcript || transcript.trim() === '' || selectedSessionId === null) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '60vh',
        color: '#aaa',
        fontSize: '1.2rem',
        fontStyle: 'italic'
      }}>
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-3">
          <svg className="animate-spin h-8 w-8 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3.5-3.5L12 0v4a8 8 0 00-8 8z" />
          </svg>
          <p className="tw-text-center tw-text-gray-500 tw-mt-2">
            Die Sitzung wird analysiert.  Anschließend können Sie hier die Dokumentation erstellen.
          </p>
        </div>
      </div>
    );
  }

  if (sessionData.id !== selectedSessionId) {
    return null; // oder ein Lade-Spinner
  }
  const doc = sessionData?.documentation?.documentation;
  if (!doc || doc.trim() === '') {
    return (
      <>
<div className="lg:w-[95%] max-h-[75vh] overflow-auto px-2 py-6 pt-6 pb-10 bg-white rounded-lg shadow-md">          <div className="tw-grow tw-flex tw-flex-col">
            <div className="upload-form">
              <div className="upload-form__container">
                <div className="upload-form__container__main__header tw-w-full sm:!w-[60vw]"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    minHeight: '4.5rem' // oder eine andere feste Höhe
                  }}>
                  <h3 className="upload-form__container__main__h3" >Dokumentation generieren</h3>
                  <p className="upload-form__container__main__p">Vervollständigen Sie die Sitzungdetails um die Dokumention zu erstellen </p>
                </div>
                <ConfigureDialogContent open={dialogOpen} setOpen={setDialogOpen} />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <style>
        {`
  .ql-editor ul:hover,
  .ql-editor li:hover {
    background: transparent !important;
    outline: none !important;
    box-shadow: none !important;
  }

  .ql-editor ul,
  .ql-editor ol,
  .ql-editor li {
    background: transparent !important;
    margin-top: 0.em;
    
  }

  .ql-editor h1,
  .ql-editor h2,
  .ql-editor h3,
  .ql-editor h4,
  .ql-editor h5,
  .ql-editor h6 {
    margin-top: 2.5em;
    margin-bottom: 0.3em;
  }
  @keyframes pulse {
    0% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.1); opacity: 0.7; }
    100% { transform: scale(1); opacity: 1; }
  }
  .pulsing-mic {
    display: inline-block;
    animation: pulse 1s infinite ease-in-out;
  }
`}
      </style>


      <div className="_PageContent_kyudy_22">
        <div id="note-documentation" className="sign_notes">
          <div className="sign_notes__editor">
            <div className="sign_notes__editor__content">
              <div id="summary-header-row" className="summary-header-row tw-flex tw-items-center tw-justify-between tw-overscroll-auto tw-w-full">
                <div className="tw-flex tw-items-center tw-gap-3">
                  <h3 className="summary-section-title tw-mb-0">
                    <span className="">{labelMap[sessionData?.session_type || "Progress Note"]}</span>
                  </h3>
                </div>
                <div id="note-documentation-buttons" className="summary-buttons-section">

                  <div className="note-options tw-flex tw-items-center" id="note-options">
                    <Tooltip text="Ein-/ Ausblenden">
                      <div className="hidden md:tw-block" onClick={() => setShowSessionDetails(prev => !prev)}>
                        <div className="NA__container ">
                          <span className="toggle__NA "> Details</span>
                          <span className={`toggle-round-button ${showSessionDetails ? 'active' : ''}`}>
                            <div className={`toggle-round-button-inner ${showSessionDetails ? 'ball-active' : ''}`}></div>
                          </span>
                        </div>
                      </div>
                    </Tooltip>
                    <div className="summary-button pr-1 tw-cursor-default">
                        {sessionData?.documentation_locked ? (
                          <Tooltip text="Speichern nicht mehr möglich.">
                            <CloudDoneIcon sx={{ color: "#ccc", fontSize: 29 }} />
                          </Tooltip>
                        ) : isEdited ? (
                          <button data-state="closed" className=" summary-button summary-icon-records-button">
                          <Tooltip text="Speichern">
                            <CloudSyncIcon sx={{ color: "#eab64e", fontSize: 29 }} />
                          </Tooltip></button>
                        ) : (
                          <Tooltip text="Gespeichert">
                            <CloudDoneIcon sx={{ color: "#40937a", fontSize: 29 }} />
                          </Tooltip>
                        )}
                     
                    </div>
                    <div>


                      <>
                        <Tooltip text="Herunterladen">
                          <button
                            type="button"
                            className="summary-button summary-icon-records-button"
                            disabled={!isCompleted}
                            onClick={handleDownloadClick}
                          >
                            {/*!tw-hidden sm:!tw-flex <- für die button klasse zum verstecken */}
                            <img src="/download.png" alt="download icon" className="tw-w-[40px]" />
                          </button>
                        </Tooltip>

                        <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                          <MenuItem onClick={handleDownloadText}>Reiner Text (.txt)</MenuItem>
                          <MenuItem onClick={handleDownloadWord}>Word (.docx)</MenuItem>
                          <MenuItem onClick={handleDownloadPDF}>PDF (.pdf)</MenuItem>
                        </Menu>
                      </>
                    </div>
                    <div>
                      <button data-state="closed" disabled={!isCompleted}></button>
                      {!copyFeedbackVisible && (<Tooltip text="Kopieren">
                        <button
                          type="button"
                          className="summary-button summary-icon-records-button"
                          disabled={!isCompleted}
                          onClick={handleCopyToClipboard}
                        >
                          <img src="/copy.png" alt="copy icon" className="tw-w-[40px]" />
                        </button>
                      </Tooltip>)}

                      {copyFeedbackVisible && (
                        <span style={{ fontSize: '1.15rem', color: 'green', marginLeft: '0.2rem', marginRight: '0.5rem' }}>
                          ✔️
                        </span>
                      )}
                    </div>

                    {/* <div className="custom-dropdown">
                      <div className="dropdown-trigger-icon">
                        <img src="iscons/dropdown.png" alt=":" className="!w-z-1" />
                      </div>
                    </div>*/}
                  </div>
                  <div id="record-tooltip">
                    <button
                      type="button"
                      onClick={sessionData?.transcript_deleted ? undefined : () => handleOpenDialog()}
                      className="_button_19rto_40 _primary_19rto_127 _filled_19rto_80 _smButton_19rto_188 !tw-font-normal smButton tw-ml-4 "
                      disabled={!isCompleted || sessionData?.transcript_deleted}
                    >
                      <div className="_btnFlex_19rto_32">
                        <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          {!isCompleted ? (
                            <svg className="animate-spin h-5 w-5 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3.5-3.5L12 0v4a8 8 0 00-8 8z" />
                            </svg>
                          ) : sessionData?.transcript_deleted ? (
                            <>Gespeichert</>
                          ) : (
                            <>
                              <span className="hidden lg:inline">Neu erstellen</span>
                              <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 6V3L8 7l4 4V8c2.76 0 5 2.24 5 5a5.002 5.002 0 0 1-9.9 1H5.07a7.003 7.003 0 0 0 13.93-1c0-3.87-3.13-7-7-7z" />
                              </svg>
                            </>
                          )}
                        </span>
                      </div>
                    </button>
                  </div>
                  {/*<div id="record-tooltip">
                    <button type="button" className="_button_19rto_40 _primary_19rto_127 _filled_19rto_80 _smButton_19rto_188 !tw-font-normal smButton">
                      <div className="_btnFlex_19rto_32">Save to records</div>
                    </button>
                  </div>*/}
                </div>
              </div>

              <div className="summary-section-column">
                <div className="event-note">
                  <div className="tw w-100">
                    {showSessionDetails && <SessionDetails />}
                    <div dir="ltr" data-orientation="horizontal" style={{ display: "grid", gridTemplateRows: "auto 1fr", height: "100%", marginBottom: "10rem" }}>
                      <div className="tw-text-gray-500 tw-flex-1">
                        <div style={{ display: "grid", gridTemplateRows: "1fr auto", height: "100%" }}>
                          <div className="tw-flex tw-items-center tw-justify-between tw-overflow-hidden">
                            <div className="tw-flex tw-items-center tw-gap-3">
                              {/*<h3 className="summary-section-title tw-mb-0 tw-mt-5">
                              <span className="">Dokumentation</span>
                            </h3>*/}
                            </div>
                          </div>
                          <div id="onboarding-step-three" className="" data-state="active" data-orientation="horizontal" role="tabpanel" aria-labelledby="radix-320-trigger-clinical" >
                            <div className="tw-overflow-hidden">
                              <div className="  -container tw-relative">
                                <div className="quill session-summary-textarea">
                                  {!quillVisible ? (
                                    <div style={{
                                      textAlign: "center",
                                      padding: "2rem",
                                      color: "#888",
                                      fontStyle: "italic"
                                    }}>
                                      <div className="tw-flex tw-items-center tw-gap-2 tw-justify-center">
                                        <svg className="animate-spin h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3.5-3.5L12 0v4a8 8 0 00-8 8z" />
                                        </svg>
                                        <span></span>
                                      </div>
                                    </div>
                                  ) : (
                                    isCompleted && quillMounted && (
                                      <div id="note-documentation-quill">
                                      <ReactQuill
                                        ref={quillRef}
                                        theme="snow"
                                        value={editorContent}
                                        modules={modules}
                                        onChange={(value) => {
                                          if (isSystemUpdate.current) {
                                            htmlContentRef.current = value;
                                            isSystemUpdate.current = false;
                                          }
                                          if (!initialMountDone.current) {
                                            htmlContentRef.current = value;
                                          }
                                          initialMountDone.current = true;
                                          setEditorContent(value);
                                          editorContentRef.current = value;
                                        }}
                                        placeholder="Schreiben Sie hier Ihre Notizen..."
                                        onKeyDown={(e) => {
                                          if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
                                            e.stopPropagation(); // Verhindert, dass andere Komponenten diese Tasten abfangen
                                          }
                                        }}
                                        onChangeSelection={(range) => {
                                          const toolbarButton = document.querySelector('.ql-toolbar button.ql-dictation') as HTMLButtonElement | null;
                                          if (toolbarButton) {
                                            toolbarButton.disabled = !range;
                                          }
                                        }}
                                      /></div>
                                    )
                                  )}

                                </div>
                              </div>
                              {/*  <div className="rating-section">
                        <button type="button" className="rating-icon">
                          <img src="documentation_files/ThumbsUpPrimary-bc366b81.svg" alt="Good" />
                        </button>
                        <span className="rating-text">Rate</span>
                        <button type="button" className="rating-icon">
                          <img src="documentation_files/ThumbsDownPrimary-fbbc4125.svg" alt="bad" />
                        </button>
                      </div>*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
      <ConfigureDialog open={dialogOpen} setOpen={setDialogOpen} />
      {isRecordingVisible && (
        <div style={{
          position: 'fixed',
          bottom: '1.5rem',
          right: '1.5rem',
          backgroundColor: recordingRef.current ? '#f44336' : '#eab54d',  
          color: 'white',
          padding: '0.75rem 1.5rem',
          borderRadius: '0.75rem',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          fontSize: '1rem'
        }}>
          <span className="pulsing-mic">🎙️</span>
          {recordingRef.current ? 'Aufnahme läuft...' : 'Wird verarbeitet...'}
          {recordingRef.current && (
            <button
              onClick={() => {
                if (recordingRef.current) {
                  mediaRecorder?.stop();
                  recordingRef.current = false;
                  setIsRecordingVisible(true);
                }
              }}
              style={{
                backgroundColor: '#ffffff',
                color: '#f44336',
                border: 'none',
                borderRadius: '0.5rem',
                padding: '0.25rem 0.75rem',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              Stopp
            </button>
          )}
        </div>
      )}
    </>
  );
}
export default Documentation;   